<ng-container *ngIf="warehouse$ | async as ws">
  <form [formGroup]="form" (ngSubmit)="onSubmit(ws)">
    <formly-form [form]="form" [fields]="fields" [model]="ws"></formly-form>
    <button type="submit" class="btn btn-default" mat-raised-button>
      <mat-icon>save</mat-icon>Speichern
    </button>
  </form>
</ng-container>
